import { sortByKey } from '../../utils';

export const getMonthlyBillItems = ({ pmcs, total }) => {
  const items = [];

  if (!pmcs?.length) return items;

  // show grand total
  items.push({ pmcName: 'Grand Total for all PMCs', grandTotal: total });

  // show total for each pmc
  pmcs
    .sort((a, b) => sortByKey(a, b, 'name'))
    .forEach(({ name: pmcName, id: pmcId, buildings, total: totalPerPmc }) => {
      items.push({ pmcName, pmcId, totalPerPmc });

      // show buildings and their data
      if (buildings?.length) {
        const sortableBuildings = buildings.sort((a, b) =>
          sortByKey(a, b, 'name'),
        );

        sortableBuildings.forEach((item) => {
          const building = {
            buildingName: item.name,
            buildingId: item.id,
            unitsCount: item.unitsCount,
            launchDate: item.launchDate,
            monthlyBill: item.monthlyBill,
          };

          items.push(building);
        });
      }
    });

  return items;
};
